// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".panel_3vSWU{margin-top:20px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": "panel_3vSWU"
};
module.exports = ___CSS_LOADER_EXPORT___;
